import { useContext } from "react";

import { ModalContext } from "./index";

export const useModalContext = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw Error("useModalContext must be used within a StoreProvider");
  }

  return context;
};
